import $ from "jquery";

const scrollUp = {
    bindEvents() {
        const scrollTopBtn = document.querySelector('#js-scroll-top');
        if (scrollTopBtn) {
            scrollTopBtn.addEventListener(('click'), (event) => {
                event.preventDefault();
                document.documentElement.scrollTo({top: 0, behavior: 'smooth'});
                // HACK: change focus after scrolling up
                event.currentTarget.blur();
                setTimeout(() => {
                    document.querySelector('#main-content-start').focus();
                }, 500);
            });
        }
    }
};

// DOM ready
$(() => {
    scrollUp.bindEvents();
});

export default scrollUp;
